<template>
  <div id="site">
    <!-- all_in -->
    <div class="break_box">
      <Breadcrumb>
        <breadcrumbs></breadcrumbs>
      </Breadcrumb>
    </div>
    <div class="con_all" v-if="!$route.meta.keepAliveSub">
      <div class="con_box2">
        <div class="site_pic"><img src="/../static/images/u19394.jpg"></div>
      </div>
      <div style="padding:10px 10px 10px 25px" v-for="(site,index) in sites" :key="index" v-if="site.trash!== 1">
        <a @click="pushToSite(index)" class="site_link">{{index + 1}}. {{showName(site)}}</a>
      </div>
    </div>
    <router-view :sites="sites"></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'site',
  data() {
    return {
      sites: [],
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initSites();
    },
    initSites() {
      this.getSitesData();
    },
    getSitesData() {
      axios.get(API.site)
        .then(response => {
          this.sites = response.data.filter(data => {
            return data.trash !== 1;
          });
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    handleReceivedSites() {
      this.sites = this.sites.filter(site => {
        return trash === 0;
      });
    },
    pushToSite(index) {
      this.$router.push({ name: 'site_info', params: { site: index } })
    },
    

    showName(site) {
      let show = {'CH': site.nameCh, 'EN': site.nameEn}
      return show[sessionStorage.locale];
    },
  },
}

</script>
<style lang="scss">
#site {
  a {
    color: #11574F;
  }
}

</style>



// WEBPACK FOOTER //
// Site.vue?091feaca